import { getLogger } from '#src/api/logger-with-context'
import platformClient from '#lib/platform-client'
import { getNonTransactionalHeaders } from '#lib/http-client'
import {
  adjustmentNameAllergens,
  adjustmentNameSuitables
} from '../components/filter-allergens-modal/const'

const logReference = 'Get products by category::'

const adjustTheStringWord = (stringArr, adjustment) => {
  return stringArr
    .split(',')
    ?.map(item => {
      return adjustment[item] || item
    })
    ?.join(',')
}

const modifyFilterToMatch = (allergens, suitables) => {
  let modifiedAllergens = allergens
  let modifiedSuitables = suitables
  if (allergens) {
    modifiedAllergens = adjustTheStringWord(
      modifiedAllergens,
      adjustmentNameAllergens
    )
  }
  if (suitables) {
    modifiedSuitables = adjustTheStringWord(
      modifiedSuitables,
      adjustmentNameSuitables
    )
  }

  return {
    modifiedAllergens,
    modifiedSuitables
  }
}

export const getQueryAllergen = (query, matchTheWord) => {
  let allergens = query?.allergens
  let suitables = query?.suitables
  let queries = ''

  if (matchTheWord) {
    const { modifiedAllergens, modifiedSuitables } = modifyFilterToMatch(
      allergens,
      suitables
    )
    allergens = modifiedAllergens
    suitables = modifiedSuitables
  }

  if (allergens) {
    queries += `?allergens=${allergens}`
  }
  if (suitables) {
    queries += queries?.length ? '&' : '?'
    queries += `suitables=${suitables}`
  }

  return queries
}

const getProducts = async (category, headers, queries) => {
  const endpoint = `/products/by-category/${category.id}${queries}`
  const products = await platformClient(endpoint, { headers, version: 'v3' })
  return products
}

const getProductsByCategory = async (category, ctx) => {
  const log = getLogger()
  const headers = getNonTransactionalHeaders(ctx)
  const queries = getQueryAllergen(ctx?.query, true)

  try {
    log.info({ categoryId: category.id }, `Getting products by category`)
    return await getProducts(category, headers, queries)
  } catch (error) {
    log.error({ error }, `${logReference} error`)
  }
}

export default getProductsByCategory
